
import { Prop,Component,Vue } from 'vue-property-decorator';
@Component
export default class BaseDataForm extends Vue {
    @Prop() readonly formReady!: boolean;
}
